import React, { FC, MutableRefObject, ReactElement, useEffect } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { BgType, StateSetter } from '../../../../React/Common/Types/Types'

type Props = {
    className?: string
    type: BgType
    src: string
    alt?: string
    children: ReactElement
    setIsLoaded?: StateSetter<boolean>
}

const localhostConvert = (src: string): string => src.replace('https://localhost', 'http://localhost:8084')

export const FullscreenBackground: FC<Props> = ({
    children,
    className,
    type,
    src,
    alt,
    setIsLoaded
}: Props): ReactElement => {
    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        setTimeout((): void => {
            if (isMounted.current) {
                setIsLoaded?.(true)
            }
        }, 10000)
    }, [])

    return (
        <div className={`${className} fullscreen-background-container`}>
            {type === BgType.Video ? (
                <video
                    className='fullscreen-background'
                    autoPlay
                    muted
                    loop
                    onLoadedData={(): void => {
                        setIsLoaded?.(true)
                    }}
                    onError={(): void => {
                        setIsLoaded?.(true)
                    }}
                >
                    <source src={localhostConvert(src)} type='video/mp4' />
                </video>
            ) : (
                <img
                    className='fullscreen-background'
                    src={localhostConvert(src)}
                    alt={alt}
                    onLoad={(): void => setIsLoaded?.(true)}
                />
            )}
            {children}
        </div>
    )
}
